import { Injectable, signal } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import type { CreatePayableDialogInput, CreatePayableDialogResult } from './create-payable-dialog.component';

@Injectable({ providedIn: 'root' })
export class CreatePayableDialogStateService
{
    readonly open = signal(false);
    readonly data = signal<CreatePayableDialogInput>({});

    private _result$: Subject<CreatePayableDialogResult | null> | null = null;

    ask(data: CreatePayableDialogInput = {}): Observable<CreatePayableDialogResult | null> {
        this.answer(null);
        this._result$ = new Subject<CreatePayableDialogResult | null>();
        this.data.set(data);
        this.open.set(true);

        return this._result$.asObservable();
    }

    answer(result: CreatePayableDialogResult | null): void {
        const result$ = this._result$;
        this._result$ = null;
        this.open.set(false);
        result$?.next(result);
        result$?.complete();
    }
}
